import { FC, useState } from 'react';
import { RiCheckboxCircleFill, RiInformationLine } from '@remixicon/react';
import styles from './QualityCheckRow.module.css';
import WarningOrangeIcon from '../../atoms/WarningOrangeIcon';
import PointingTooltip, { TooltipPosition } from '../../atoms/PointingTooltip';

export enum STATUS {
  VALIDATED = 'VALIDATED',
  REVIEW_SUGGESTED = 'REVIEW_SUGGESTED',
  NOT_VALIDATED = 'NOT_VALIDATED',
}

type QualityCheckRowProps = {
  icon?: React.ReactNode;
  title?: string;
  description?: string;
  className?: string;
  status?: STATUS;
  isApplicable?: boolean;
  toolTipText?: string;
};

const QualityCheckRow: FC<QualityCheckRowProps> = ({
  icon,
  title = '',
  description = '',
  className = '',
  status = '',
  isApplicable = false,
  toolTipText = '',
}) => {
  const [isTooltipVisible, setTooltipVisible] = useState(false);

  const showTooltip = () => setTooltipVisible(true);
  const hideTooltip = () => setTooltipVisible(false);
  return (
    <div className={`${className || ''} ${styles['quality-check']}`}>
      <div className={styles.icon__wrapper}>
        {icon}

        {status === STATUS.VALIDATED && isApplicable && (
          <div className={styles['checked-icon']}>
            <RiCheckboxCircleFill size={20} />
          </div>
        )}

        {status === STATUS.REVIEW_SUGGESTED && isApplicable && (
          <div
            className={`${styles['quality-check-row__review-icon--wrapper']} `}
          >
            <WarningOrangeIcon />
          </div>
        )}
      </div>

      <div className={styles['quality-check__details']}>
        <div className={styles['quality-check__details__title-wrapper']}>
          <h3 className={styles.title}>{title}</h3>
          {toolTipText && (
            <PointingTooltip
              text={toolTipText}
              showTooltip={isTooltipVisible}
              onMouseEnter={showTooltip}
              toolTipPosition={TooltipPosition.TOP_CENTER}
              onMouseLeave={hideTooltip}
              id='image-dimensions-tooltip'
              classes={styles.imageDimensionsTooltip}
            >
              <RiInformationLine size={16} className={styles.tooltipInfoIcon} />
            </PointingTooltip>
          )}
        </div>
        {description && <p className={styles.description}>{description}</p>}
      </div>
    </div>
  );
};

QualityCheckRow.displayName = 'QualityCheckRow';

export default QualityCheckRow;
